import React, { Component } from 'react';
// import { LinkContainer } from 'react-router-bootstrap';
// import { Link } from 'react-router-dom'
import moment from 'moment';
// import Icons from '../../Components/Icons/Icons';
import {dismissActivityReminderDetails,dismissAllActivityReminderDetails,getActivityReminderDetails,getUserTimeZone } from '../../Utils/UserFunctions';
import { parameterizedURLAccessToken } from '../../Utils/CommonFunctions';
// import { FaCarCrash } from 'react-icons/fa';
let reloadInterval = null;

class ReminderList extends Component {
	constructor(props) {
		super(props);
		this.state = {
            deletingId:null,
			ACTIVITY_REMINDER:this.props.ACTIVITY_REMINDER,
            showDismissAllConfirm: false,
            // reminderMessage: null
		}
        this.eventSource = null;
    }
    componentDidUpdate = (prevProps) =>{
        if(prevProps.ACTIVITY_REMINDER!==this.props.ACTIVITY_REMINDER){
          this.setState({ACTIVITY_REMINDER:this.props.ACTIVITY_REMINDER});
        }
    }
    componentDidMount() {
        // const api =encodeURIComponent(parameterizedURLAccessToken('reminders/list'));
        // const timezone = encodeURIComponent(getUserTimeZone());
        // // const encodedUrl = encodeURIComponent(parameterizedURLAccessToken(API_Url));
        // const SSE_URL = `https://dev.shipcrm.org/reminder-events?api=${api}&timezone=${timezone}`;
        // //http://localhost:4000 https://dev.shipcrm.org
        // this.eventSource = new EventSource(SSE_URL);

        // this.eventSource.onmessage = (event) => {
        // const resData = JSON.parse(event.data);
        // if (resData.isExist === 200) {
        //     localStorage.setItem('ACTIVITY_REMINDER', JSON.stringify(resData.message));
        //     this.props.setReminderMessage(resData.message);
        // }
        // };

        // this.eventSource.onerror = (error) => {
        // console.error('SSE error:', error);
        // this.eventSource.close();
        // };
    }

    componentWillUnmount() {
        // console.log('unmount..');
        // if (this.eventSource) {
        // this.eventSource.close();
        // }
    }

	render() {
        const {reminderListPopupToogle} = this.props;
        const {ACTIVITY_REMINDER,deletingId,showDismissAllConfirm} =  this.state;
        const reminderIds = Object.keys(ACTIVITY_REMINDER || {}).filter(
            (id) => ACTIVITY_REMINDER[id] && ACTIVITY_REMINDER[id].OnlyDisplayText === false
        );
        const totalCount = Object.keys(ACTIVITY_REMINDER || {}).length;
      
        try{ 
            return (	
                <>
                <div className="row notifyBox animated fadeInUp reminderNotifyBox"  style={{display:'none'}}>
                   
                    <div className="col-12">
                        <div className="card">
                            <div className="card-header">
                                <h6 className="mb-0 last_light_color">
                                    Reminders
                                    {totalCount > 0 ? <span className="reminder-count-badge">{totalCount}</span> : null}
                                </h6>
                                <a href="#" className="icon-right cursor-pointer" id="">
                                    <span className="badge badge-warning" onClick={e=>reminderListPopupToogle(false)}><i className="fas fa-times fa-lg"></i></span>
                                </a>
                            </div>
                            
                            <div className="list-group list-group-file-item list-group-reflow list-group-flush list-group-divider">
                            {(Object.keys(ACTIVITY_REMINDER).length>0)?
                                <ol className="activity-feed">
                                    {Object.entries(ACTIVITY_REMINDER)
                                        .sort(([keyA, remindA], [keyB, remindB]) => {
                                            // Sort by NextFireTime in ascending order (earliest first)
                                            let timeA = Number.MAX_SAFE_INTEGER; // Default: put invalid dates at the end
                                            let timeB = Number.MAX_SAFE_INTEGER; // Default: put invalid dates at the end
                                            
                                            if (remindA.NextFireTime && remindA.NextFireTime !== '' && remindA.NextFireTime !== undefined && remindA.NextFireTime !== null) {
                                                const momentA = moment(remindA.NextFireTime, 'YYYY-MM-DDTHH:mm', true);
                                                if (momentA.isValid()) {
                                                    timeA = momentA.valueOf();
                                                }
                                            }
                                            
                                            if (remindB.NextFireTime && remindB.NextFireTime !== '' && remindB.NextFireTime !== undefined && remindB.NextFireTime !== null) {
                                                const momentB = moment(remindB.NextFireTime, 'YYYY-MM-DDTHH:mm', true);
                                                if (momentB.isValid()) {
                                                    timeB = momentB.valueOf();
                                                }
                                            }
                                            
                                            return timeA - timeB; // Ascending order (earliest reminders first)
                                        })
                                        .map(([key, remind]) => {
                                        //  const currentTime = moment().tz(getUserTimeZone()).format('YYYY-MM-DDTHH:mm');
                                            let isDisplayed = 0;
                                            let displayDateTime = (remind.NextFireTime!=='' && remind.NextFireTime!==undefined && remind.NextFireTime!==null)?moment(remind.NextFireTime, 'YYYY-MM-DDTHH:mm', true).format('YYYY-MM-DD hh:mm A'):'YYYY-MM-DD hh:mm';
                                            let displayDate = (remind.NextFireTime!=='' && remind.NextFireTime!==undefined && remind.NextFireTime!==null)?moment(remind.NextFireTime, 'YYYY-MM-DDTHH:mm', true).format("MMM Do YYYY"):'MMM YYYY';
                                            // console.log('remind.DisplayText',remind.DisplayText);
                                            // let displayCount = 0;
                                            return(
                                                <li className="feed-item feed-item-warning" key={`item-${key}`}>
                                                    {(deletingId===key)&& 
                                                        <div id="loaderBG" style={{position:'absolute',backgroundColor:'#fff'}}>
                                                            <div className="loader11" style={{position:'relative',left:'40%',top:'50%'}}></div>
                                                        </div> 
                                                    } 
                                                    
                                                    <time className="date text-info"> <span className="badge-info badge"> {displayDate} </span> </time>
                                                        <div className="d-flex align-items-start justify-content-between">
                                                        <div>
                                                        {(remind.OnlyDisplayText===false)?
                                                            <span className="text secondary_color">{displayDateTime}</span>
                                                        :''}
                                                        {
                                                        remind.DisplayText && Object.keys(remind.DisplayText).length>0?    
                                                            <ul>
                                                            {Object.entries(remind.DisplayText).map(([displayKey, text]) => {
                                                                // if (isDisplayed > 2) return null;
                                                                if (displayKey === 'record_id') return null;

                                                                isDisplayed++;
                                                                return (
                                                                    <li key={displayKey} title={text} className='text-right1 text-truncate1'>
                                                                        {text}
                                                                    </li>
                                                                );
                                                            })}
                                                        </ul>
                                                        :''}
                                                        </div>
                                                        {(remind.OnlyDisplayText===false)?
                                                            <span className="reminder-item-dismiss" onClick={(e=>this.dismissHandler(key))}>Dismiss</span>
                                                        :''}
                                                        </div>
                                                </li>
                                            )
                                    })}
                                    
                                </ol>
                            :<h6 className="p-3">{`No reminder exists`}</h6>}
                            </div>
                            {reminderIds.length >= 2 &&
                                <div className="reminder-dismiss-all-foot">
                                    <span>{totalCount} reminders</span>
                                    <button type="button" className="reminder-dismiss-all-foot__btn" onClick={()=>this.setState({showDismissAllConfirm:true})}>
                                        Dismiss all
                                    </button>
                                </div>
                            }
                        </div>
                    </div>
                </div>
                {showDismissAllConfirm &&
                    <div className="reminder-dismiss-confirm">
                        <div className="reminder-dismiss-confirm__backdrop" onClick={()=>this.setState({showDismissAllConfirm:false})}></div>
                        <div className="reminder-dismiss-confirm__dialog">
                            <h3 className="reminder-dismiss-confirm__title">Dismiss all reminders?</h3>
                            <p className="reminder-dismiss-confirm__text">{`All ${reminderIds.length} reminders will be removed from your active list.`}</p>
                            <div className="reminder-dismiss-confirm__actions">
                                <button type="button" className="reminder-dismiss-confirm__btn reminder-dismiss-confirm__btn--ghost" onClick={()=>this.setState({showDismissAllConfirm:false})}>Cancel</button>
                                <button type="button" className="reminder-dismiss-confirm__btn reminder-dismiss-confirm__btn--danger" onClick={this.dismissAllHandler}>Dismiss all</button>
                            </div>
                        </div>
                    </div>
                }
                </>
            );
        }catch(e){
            return('')
        }
	}

	dismissHandler = (remidId)=>{
        this.setState({deletingId:remidId},()=>{
            dismissActivityReminderDetails(remidId,this.reloadActivityReminderList);
        })
    }

    dismissAllHandler = () => {
        const reminderIds = Object.keys(this.state.ACTIVITY_REMINDER || {}).filter(
            (id) => this.state.ACTIVITY_REMINDER[id] && this.state.ACTIVITY_REMINDER[id].OnlyDisplayText === false
        );
        this.setState({showDismissAllConfirm: false}, () => {
            if (reminderIds.length < 2) return;
            dismissAllActivityReminderDetails(reminderIds, this.reloadActivityReminderList);
        });
    }

    reloadActivityReminderList = ()=>{
       let ACTIVITY_REMINDER = {};
       let activityReminder  = localStorage.getItem('ACTIVITY_REMINDER');
       console.log('activityReminder',activityReminder)
        try{
            if(activityReminder!==null && activityReminder!==undefined){
                ACTIVITY_REMINDER = JSON.parse(activityReminder);
                if(this.state.ACTIVITY_REMINDER!==ACTIVITY_REMINDER){
                    // clearInterval(reloadInterval);
                    this.setState({ACTIVITY_REMINDER:ACTIVITY_REMINDER});
                }
                
            }
        }catch(e){
   
        }
    }
	//REMINDER BLOCK END
} 

export default (ReminderList);

